import React, { useEffect, FC } from 'react'

import {
  useLocation,
  useHistory
} from "react-router-dom"

import { Helmet } from "react-helmet"

/* Data */
import { useAppDispatch, useAppSelector } from "@/app/hooks"

import {
  setPropzMediaStateParameter
} from "@/features/propzMedia/propzMediaSlice"

import {
  actions,
  useTrackedStore,
  store,
} from '@assets/store'
import { pdcStore } from '@assets/store/pdcStore'

export const WebPushPage: FC = () => {

  const history = useHistory()

  const dispatch = useAppDispatch()

  const { search } = useLocation()

  const customer = useTrackedStore().app.customer()

  useEffect(() => {
    if (customer?.webPushContactFlag) {
      pdcStore.set.WebpushModalOpened(false)
      history.push(`/${search}`)
    } else {
      pdcStore.set.WebpushModalOpened(true)
    }
  }, [customer?.webPushContactFlag])

  return (
    <Helmet>
      <title>Aceita receber notificações web</title>
      <meta name="description" content="Solicitação para envio de notificações web." />
    </Helmet>
  )
}